import { useIntl } from 'react-intl';
import { forwardRef } from '@chakra-ui/react';

import { Table } from '../../Table';
import { type RowProps } from '../../Table/parts';
import { useFees } from '../context';

export type CardPayoutNonEuroProps = RowProps;

export const CardPayoutNonEuro = forwardRef<CardPayoutNonEuroProps, 'div'>(
  (props, ref) => {
    const intl = useIntl();
    const { fees, toFixed, toVariable } = useFees();

    const locales = {
      label: intl.formatMessage({
        id: 'subscription.fees_modal.card_payout_non_euro.label',
      }),
      value: intl.formatMessage(
        {
          id: 'subscription.fees_modal.card_payout_non_euro.value',
        },
        {
          fixed: toFixed(fees.cardPayoutNonEuro),
          variable: toVariable(fees.cardPayoutNonEuro),
        },
      ),
    };

    return (
      <Table.Row {...props} ref={ref}>
        <Table.CellText>{locales.label}</Table.CellText>
        <Table.CellAmount>{locales.value}</Table.CellAmount>
      </Table.Row>
    );
  },
);
